import { render } from "./PrivacyPolicy.vue?vue&type=template&id=2babfe06&scoped=true&ts=true"
import script from "./PrivacyPolicy.vue?vue&type=script&lang=ts"
export * from "./PrivacyPolicy.vue?vue&type=script&lang=ts"

import "./PrivacyPolicy.vue?vue&type=style&index=0&id=2babfe06&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/hems-frontend-vue_eu_v1.33.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2babfe06"]])

export default __exports__